import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const DAVID_PHOTO = "https://customer-assets.emergentagent.com/job_call-capture-ai-1/artifacts/bifze25o_489307596_1181526706760893_3359884689589176842_n.jpg";
const NOAH_PHOTO = "https://customer-assets.emergentagent.com/job_call-capture-ai-1/artifacts/ldp97uiu_1000033782.webp";

const team = [
  {
    name: "Noah Johnson",
    role: "Founder",
    bio: "Built Velocity Labs to solve a problem; plumbers losing jobs because they couldn't answer the phone. The face of Velocity Labs.",
    photo: NOAH_PHOTO,
    initials: "NJ",
  },
  {
    name: "David Pang",
    role: "Sales Executive",
    bio: "Responsible for reaching plumbers who are in need of our services.",
    photo: DAVID_PHOTO,
    initials: "DP",
  },
  {
    name: "Elijah Miller",
    role: "CTO",
    bio: "Engineers the AI systems that make every lead count. Speed and reliability are his obsession.",
    photo: null,
    initials: "EM",
  },
];

export default function TeamSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
      style={{ backgroundColor: "#0D0D0D" }}
    >
      <div className="max-w-7xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span
            className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-[#5B8DEF] font-medium mb-4"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="team-label"
          >
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
            Our Team
            <span className="w-6 h-px bg-[#5B8DEF]"></span>
          </span>
          <h2
            className="text-3xl md:text-4xl tracking-tight font-semibold text-white"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="team-headline"
          >
            Built by People Who Get It
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {team.map((member, i) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.12 * (i + 1) }}
              data-testid={`team-member-${i}`}
              className="group bg-[#121212] border border-white/[0.06] rounded-lg p-7 text-center hover:border-white/[0.12] transition-all duration-300"
            >
              {member.photo ? (
                <img
                  src={member.photo}
                  alt={member.name}
                  className="w-20 h-20 rounded-full object-cover mx-auto mb-5 grayscale group-hover:grayscale-0 transition-all duration-500"
                />
              ) : (
                <div className="w-20 h-20 rounded-full bg-[#1A1A1A] border border-white/[0.08] flex items-center justify-center mx-auto mb-5">
                  <span
                    className="text-xl font-semibold text-[#A3A3A3]"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {member.initials}
                  </span>
                </div>
              )}

              <h3
                className="text-lg font-semibold text-white mb-1"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {member.name}
              </h3>
              <p
                className="text-sm text-[#5B8DEF] font-medium mb-3"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {member.role}
              </p>
              <p
                className="text-sm text-[#A3A3A3] leading-relaxed"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {member.bio}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
